import { useEffect, useState } from "react";
import {
  Box, Card, Chip, MenuItem, Stack, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TextField, Typography,
} from "@mui/material";
import { useLanguage } from "../../i18n/LanguageContext";
import { bookingsApi } from "../../api/resources";

export default function BookingsHistoryTable({ areas }) {
  const { t, lang } = useLanguage();
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [unit, setUnit] = useState("");
  const [areaId, setAreaId] = useState("");
  const [bookings, setBookings] = useState([]);

  const fmtDate = (iso) => new Date(iso + "T00:00:00").toLocaleDateString(lang === "en" ? "en-US" : "es-MX", { day: "2-digit", month: "short", year: "numeric" });

  useEffect(() => {
    const params = {};
    if (from) params.from = from;
    if (to) params.to = to;
    if (unit) params.unit = unit;
    if (areaId) params.areaId = areaId;
    const id = setTimeout(() => bookingsApi.list(params).then(setBookings), 200);
    return () => clearTimeout(id);
  }, [from, to, unit, areaId]);

  const areaName = (id) => areas.find((a) => a._id === id)?.name || "—";

  return (
    <Box>
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap sx={{ mb: 2 }}>
        <TextField size="small" type="date" label={t("areas.filterFrom")} value={from} onChange={(e) => setFrom(e.target.value)} InputLabelProps={{ shrink: true }} />
        <TextField size="small" type="date" label={t("areas.filterTo")} value={to} onChange={(e) => setTo(e.target.value)} InputLabelProps={{ shrink: true }} />
        <TextField size="small" label={t("areas.filterUnit")} value={unit} onChange={(e) => setUnit(e.target.value)} sx={{ width: 140 }} />
        <TextField select size="small" label={t("areas.filterArea")} value={areaId} onChange={(e) => setAreaId(e.target.value)} sx={{ minWidth: 180 }}>
          <MenuItem value="">{t("areas.allAreas")}</MenuItem>
          {areas.map((a) => (
            <MenuItem key={a._id} value={a._id}>
              {a.name}
            </MenuItem>
          ))}
        </TextField>
      </Stack>

      <TableContainer component={Card}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: "#F4F5EF" }}>
              <TableCell>{t("historial.colDate")}</TableCell>
              <TableCell>{t("areas.colArea")}</TableCell>
              <TableCell>{t("areas.colTime")}</TableCell>
              <TableCell>{t("areas.colUnit")}</TableCell>
              <TableCell>{t("areas.colContact")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bookings.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 5, color: "text.secondary" }}>
                  {t("areas.noBookings")}
                </TableCell>
              </TableRow>
            )}
            {bookings.map((b) => (
              <TableRow key={b._id} hover>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">{fmtDate(b.date)}</Typography>
                </TableCell>
                <TableCell>{areaName(b.areaId)}</TableCell>
                <TableCell>
                  {b.fullDay ? (
                    <Chip size="small" label={t("areas.modeFullDay")} />
                  ) : (
                    `${String(b.startHour).padStart(2, "0")}:00 – ${String(b.endHour).padStart(2, "0")}:00`
                  )}
                </TableCell>
                <TableCell>
                  <Chip size="small" label={b.occupantId?.unit} sx={{ fontWeight: 600 }} />
                </TableCell>
                <TableCell>{b.occupantId?.name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
